export const webURL = 'https://www.artoflogic.ai';

// bar chart colors
export const selectedBarBorderColor = '#ccc';
export const barBackgroundColorLineCrossing = '#64C6E6';
export const barBackgroundColorReverseLineCrossing = '#8E338C';

export const samuraiOrange = "#F49523";

// Occupancy colors
export const peopleOccupancyColor = '#4A9EFF'; // Orange
export const lprOccupancyColor = '#FFC400'; // Blue
export const peopleDwellColor = '#9BE2EE'; // Lavender

// Camera comparison colors - used when comparing multiple cameras
export const CAMERA_COLORS = [
  '#A478E8', // Lavender
  '#64C6E6', // Blue (matches Line Crossing)
  '#8E338C', // Purple (matches Reverse Line Crossing)
  '#4ECDC4', // Teal
  '#8328FF', // Dark Purple
  '#4683FE', // Light Blue
  '#9D5C63', // Mauve
  '#5FC3E4', // Sky Blue
  '#E056FD', // Bright Purple

];

export const countAnalytics = '#C147FF';
// People Occupancy:  
export const peopleOccupancyColor2 = '#4A9EFF';
// People Dwell
//     -      People Occupancy: 9BE2EE    -     ALPR & Infringement: FFC400